import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatisIso = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PageHeader
                        title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons imageKey="ISO Standards" title={"ISO Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box
                    sx={{
                        borderRadius: '8px',
                        padding: '24px',
                        top: '226px',
                        left: '75px',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: '#2E7D32',
                            mb: 3,
                            fontFamily: 'DM Sans',
                            fontSize: '40px',
                            lineHeight: '38px',
                        }}
                    >
                        The global standards for sustainability<br /> impacts
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        <Typography
                            component="h4"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 800,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 1,
                            }}
                        >
                            What Are ISO Standards?
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            ISO standards are globally recognized technical, managerial, and operational frameworks established by the International Organization for Standardization (ISO), an independent international body.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            These standards set uniform requirements, guidelines, and best practices across diverse fields to ensure that products, services, systems, and processes are reliable, safe, efficient, environmentally sound, and socially responsible.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            Key features of ISO standards include:
                        </Typography>
                        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Promoting international harmonization for trade and collaboration
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Setting benchmark practices for risk management, quality, environmental performance, health and safety, energy use, governance, social responsibility, greenhouse gas (GHG) accounting, and anti-corruption
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Supporting organizations in complying with laws, improving operational performance, reducing risks, and enhancing stakeholder trust
                            </Typography>
                        </Box>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            Major ISO standards relevant to ESG and sustainability topics include:
                        </Typography>
                        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 14001 (Environmental Management) → managing environmental impacts and driving continuous improvement
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 45001 (Occupational Health & Safety) → ensuring safe and healthy workplaces
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 9001 (Quality Management) → embedding consistent product/service quality
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 50001 (Energy Management) → optimizing energy performance and efficiency
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 26000 (Social Responsibility) → guiding organizations in ethical, fair, and responsible behavior
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 14064 (GHG Accounting) → quantifying and reporting GHG emissions
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 20400 (Sustainable Procurement) → integrating sustainability in purchasing practices
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 31000 (Risk Management) → establishing structured risk frameworks across operations
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                ISO 37001 (Anti-Bribery) → preventing bribery and promoting ethical conduct
                            </Typography>
                        </Box>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            Together, these standards help organizations align their strategies with global sustainability goals, such as the UN Sustainable Development Goals (SDGs), meet the expectations of investors, regulators, and clients, and ensure transparent reporting and accountability.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <a
                        href="https://www.iso.org/standards.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                    >
                        <CustomButton title="Access to full ISO Standard" />
                    </a>
                </Box>
            </Grid>
        </Grid>
    );
};

export default WhatisIso;